import { Helmet } from 'react-helmet-async';

const ContactPageHelmet = () => {
  return (
    <Helmet>
      <title>Contact Us | Interlink Oceana</title>
      <meta
        name='description'
        content='Get in touch with Interlink Oceana for reliable global shipment solutions. Our team is here to assist with all your logistics and shipping needs.'
      />

      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.interlinkoceana.com/contact'
      />
      <meta
        property='og:title'
        content='Contact Interlink Oceana | Global Shipment Solutions'
      />

      <meta
        property='og:image'
        content='https://www.interlinkoceana.com/assets/img/inter-i-logo.png'
      />
      <meta
        property='og:description'
        content='Reach out to Interlink Oceana for expert guidance on shipment and logistics services. We provide tailored solutions to streamline your global shipping operations.'
      />

      <meta property='og:site_name' content='Interlink Oceana' />
      <meta property='og:locale' content='en_US' />
    </Helmet>
  );
};

export default ContactPageHelmet;
